
export default function SafetyNotice() {
  return (
    <div className="bg-[#2d5f5d]/10 border-l-4 border-[#2d5f5d] rounded-r-lg p-4 my-6">
      <div className="flex items-start">
        <i className="ri-alert-line text-[#2d5f5d] text-xl mr-3 mt-0.5"></i>
        <div>
          <p className="text-sm font-semibold text-[#1e3a5f] mb-1">
            Wichtiger Hinweis
          </p>
          <p className="text-sm text-gray-700 leading-relaxed">
            Hund-im-Alter ersetzt keine tierärztliche Diagnose. Bei plötzlichen Veränderungen, 
            Schmerzen oder Unsicherheit konsultieren Sie bitte Ihren Tierarzt.
          </p>
        </div>
      </div>
    </div>
  );
}
